import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '../../../../../config/tenants/global';
import { subscriptionTierConfig } from './config';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ subscriptionTier = 'Tenna' }) => {
  return {
    leftform_getSubscriptionTier: {
      [SERVICE_PROVIDERS.EM]: () => subscriptionTierConfig[SERVICE_PROVIDERS.EM]?.(subscriptionTier),
      [SERVICE_PROVIDERS.TP]: () => subscriptionTierConfig[SERVICE_PROVIDERS.TP]?.(subscriptionTier),
      [SERVICE_PROVIDERS.GS]: () => subscriptionTierConfig[SERVICE_PROVIDERS.GS]?.(subscriptionTier),
      default: () => subscriptionTierConfig['default']?.(subscriptionTier),
    },
    disabled_field: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    leftform_fields: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      default: () => true,
    },
    leftform_oldviewAlign: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    leftform_labels: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => i18n.t('companyData.noOfCameras'),
      default: () => i18n.t('companyData.noOfTrucks'),
    },
    rightform_fields: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    rightform_fields_settings: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => false,
    },
    rightform_cModal: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
